

export class TemperatureCalibrationUpdateInput implements ITemperatureCalibrationUpdateInput {
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId!: number;
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The multiplication factor */
    multiplicationFactor!: number;
    /** The temperature Unit */
    temperatureUnit!: number;

    constructor(data?: ITemperatureCalibrationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperatureCalibrationId = _data["temperatureCalibrationId"];
            this.branchDetailId = _data["branchDetailId"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.multiplicationFactor = _data["multiplicationFactor"];
            this.temperatureUnit = _data["temperatureUnit"];
        }
    }

    static fromJS(data: any): TemperatureCalibrationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperatureCalibrationId"] = this.temperatureCalibrationId;
        data["branchDetailId"] = this.branchDetailId;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["multiplicationFactor"] = this.multiplicationFactor;
        data["temperatureUnit"] = this.temperatureUnit;
        return data; 
    }
}

export interface ITemperatureCalibrationUpdateInput {
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId: number;
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The multiplication factor */
    multiplicationFactor: number;
    /** The temperature Unit */
    temperatureUnit: number;
}

